<template>
  <div class="events-feed events-feed--small">
    <h2 class="heading-2">{{monthOneTitle}}</h2>
    <results :has-carousel="false" :position="0"></results>
    <h2 class="heading-2">{{monthTwoTitle}}</h2>
    <results :has-carousel="false" :position="1"></results>
    <h2 class="heading-2">{{monthThreeTitle}}</h2>
    <results :has-carousel="false" :position="2"></results>
  </div>
</template>

<script>
import moment from 'moment'
import Results from './elementEvents.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Results
  },
  computed: {
    monthOneTitle () {
      return moment()
        .add(this.offsetMultiplier, 'months')
        .format('MMMM Y')
    },
    monthTwoTitle () {
      return moment()
        .add(this.offsetMultiplier + 1, 'months')
        .format('MMMM Y')
    },
    monthThreeTitle () {
      return moment()
        .add(this.offsetMultiplier + 2, 'months')
        .format('MMMM Y')
    },
    ...mapGetters('events', ['offsetMultiplier'])
  }
}
</script>
